<template>
  <!-- 0429 a-left 추가 -->
  <div class="a-left">
    <div class="title-h4 title-bar">미터링 (서비스 과금) 정의</div>
    <div class="mr-b15">
      사용량 기반 IT 서비스 모델에서 제공하는 서비스에 대한 정확한 과금을 위해<br />
      수행하는 사용량 측정, 사용량 데이터 집계 및 서비스 요금 산정을 의미한다.<br />
      - 서비스 가격 = 자원 량 * 자원 단가
    </div>
    <hr class="mr-b15" />
    <div class="title-h4 title-bar">자원 량</div>
    <div class="mr-b15" style="display: table">
      <div style="display: table-cell">
        - 할당받은 vCPU 수<br/>
        - 디스크 볼륨 할당량<br />
      </div>
      <div style="display: table-cell; padding-left: 30px">
        - MEM 크기 할당량<br/>
        - 네트워크 자원 사용량<br />
      </div>
    </div>
    <hr class="mr-b15" />
    <div class="title-h4 title-bar">자원 단가</div>
    <div class="mr-b15">
      자원별 기준 단위의 하루 사용 가격
    </div>
    <hr class="mr-b15" />
    <el-popover placement="bottom-start" width="700" trigger="click">
      <div style="height: 300px">
        <el-scrollbar>
          <div class="title-h4 title-bar">미터링 예시</div>
          <div class="title-bar dot-title">CPU 사용 미터링 (VM off 시에도 미터링에 포함 됨)</div>
          예) 4vCPU 사용 시<br />
          4 vCPU * 1000 (1 vCPU 당 단가) * 30 (사용일) = 120,000<br />
          <br />
          <div class="title-bar dot-title">MEM 사용 미터링</div>
          할당받은 VM의 메모리 크기 * 단가<br />
          예) 16G * 500 (1G당 단가) * 30 (사용일) = 240,000<br />
          <br />
          <div class="title-bar dot-title">DISK 사용 미터링</div>
          사용한 디스크 용량 * 단가<br />
          예) 500G * 300 * 30 = 450,000<br />
          <br />
          <div class="title-bar dot-title">NETWORK 사용 미터링</div>
          할당받은 VM의 NIC에 대한 IN / OUT Bound의 일간 총 트래픽 * 단가<br />
          예) 1000 Mbps (Out Bound 기준) * 10 (1Mbps당 단가) * 30 (사용일) = 300,000<br />
          <br />
          <div class="title-bar dot-title">미터링 총합</div>
          CPU + MEM + DISK + DISK I/O<br />
          예) 120,000 + 240,000 + 450,000 + 300,000 = 1,111,000<br />
        </el-scrollbar>
      </div>
      <el-button slot="reference">미터링 예시</el-button>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'WMeteringHelpView',
  data() {
    return {};
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/virtual/Metering/ServerVirtualization/components/MeteringHelpView.vue